// extracted by mini-css-extract-plugin
export default {"container":"resource-board_container__aiBWz","panel":"resource-board_panel__mdtQ1","toggle":"resource-board_toggle__SamQ-"};